import { defineStore } from "pinia";

export const useFollowerStore = defineStore("follower", {
	state: () => {
		return {
			followedCount: 0,
			followedIds: [],
		};
	},
	actions: {
		setFollowed(items) {
			this.followedIds = items;
			this.followedCount = Object.keys(items).length;
		},
	},
});
